import { apiClient } from '../../../utilities/apiClient';
import { store } from '../../../store';
import {
  ANONYMOUS_LOGIN_FAILED,
  ANONYMOUS_LOGIN_REQUESTED,
  ANONYMOUS_LOGIN_SUCCEEDED,
  COUNTRY,
  LANGUAGE,
} from './action';

// Phase A: anonymous bootstrap hits POST /auth/anonymous on the NestJS API
// (httpOnly cookies). Firebase signInAnonymously is gone.
export const anonymousLogin = async () => {
  store.dispatch({ type: ANONYMOUS_LOGIN_REQUESTED });
  try {
    const res = await apiClient.post('/auth/anonymous');
    store.dispatch({ type: ANONYMOUS_LOGIN_SUCCEEDED, data: res.data.user });
  } catch (e) {
    store.dispatch({
      type: ANONYMOUS_LOGIN_FAILED,
      data: e?.response?.data?.message || e?.message || 'anonymous login failed',
    });
  }
};

export const setCountry = (data) => {
  store.dispatch({ type: COUNTRY, data });
};

export const setLanguage = (data) => {
  store.dispatch({ type: LANGUAGE, data });
};
